// Utility functions for UTC <-> local date-time conversions

/**
 * Convert a JavaScript Date object (or any value accepted by Date constructor)
 * to a UTC timestamp expressed in seconds since epoch.
 * Returns null if the input is falsy or cannot be parsed.
 */
export const dateToUtcSeconds = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (isNaN(date.getTime())) return null;
  return Math.floor(date.getTime() / 1000);
};

/**
 * Convert a UTC timestamp (seconds since epoch) to a local date-time string.
 * Returns null if the input is falsy.
 */
export const utcSecondsToLocalString = (seconds) => {
  if (!seconds) return null;
  const date = new Date(seconds * 1000);
  if (isNaN(date.getTime())) return null;
  return date.toLocaleString();
};

/**
 * Helper to format a timestamp (seconds) with a fallback string.
 */
export const formatTimestamp = (seconds, fallback = "N/A") => {
  const str = utcSecondsToLocalString(seconds);
  return str ?? fallback;
};
